<template>
  <div class="crumb">
    <div class="max-w">
      您当前的位置：<router-link to="/" class="link">首页</router-link>
      <span class="link">></span>
      <span class="link">{{ this.$route.meta.title }}</span>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.crumb {
  padding: 22px 0;
  font-size: 18px;
  color: #333;
  border-bottom: 1px solid #e5e5e5;
  .link {
    color: #3d8aff;
    margin-left: 6px;
  }
}
</style>
